module.exports = __webpack_public_path__ + "img/home-14.5cfa4326.webp";